export const colorRangeMapping = [
    {
        color: 'green',
        before: 0
    },
    {
        color: 'red',
        after: 0
    }
];